export default "dist/assets/images/wk-brand-wheel-815.b175131cd74d6a56f32d128dcd4eb47d.svg";